// features/drive/components/Breadcrumb/Breadcrumb.styles.js

import styled from 'styled-components';

export const BreadcrumbWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

export const BreadcrumbItem = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;

  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};

  color: ${({ $active, theme }) => ($active ? theme.landing.text : theme.landing.textSecondary)};

  &:hover {
    color: ${({ theme }) => theme.landing.buttonBg};
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.landing.textSecondary};
`;
